// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  customerDetails: Object,
};

const DeleteSelectedCustomer = (props: Props) => {
  const {
    visible,
    close,
    submit,
    customerDetails,
  } = props;

  const deleteSelectedCustomer = () => {
    submit(customerDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedCustomer} type="danger">Delete</SpButton>,
      ]}
      title="Delete Customer"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to delete this customer?</h6>
        <SpH5 className="pb-3">
          <div>{customerDetails.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedCustomer;
